export default __webpack_public_path__ + "static/media/trash.473c30b5.svg";